// 引导里的听力快测：从 B1 开始，听懂就升一级、听不懂就降一级，方向一变或到头就停，最多三段。
// 题库只到 C1，快测给不出 C2。
export const QUICK_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1']
export const QUICK_START_LEVEL = 'B1'

// answers: [{ level, understood }]，返回 { next } 继续出题，或 { level } 结束
export function quickTestStep(answers) {
  const last = answers[answers.length - 1]
  const index = QUICK_LEVELS.indexOf(last.level)
  if (answers[0].understood) {
    if (!last.understood) return { level: QUICK_LEVELS[index - 1] }
    return index === QUICK_LEVELS.length - 1 ? { level: last.level } : { next: QUICK_LEVELS[index + 1] }
  }
  if (last.understood) return { level: last.level }
  return index === 0 ? { level: QUICK_LEVELS[0] } : { next: QUICK_LEVELS[index - 1] }
}

// 同一等级里优先挑没听过的片段，都听过就在全部里随机
export function pickQuickClip(clips, level, recentIds = [], random = Math.random) {
  const sameLevel = clips.filter(clip => clip.level === level)
  const fresh = sameLevel.filter(clip => !recentIds.includes(clip.id))
  const pool = fresh.length ? fresh : sameLevel
  return pool[Math.floor(random() * pool.length)]
}
